<template>
  <b-form-group
    label="Doküman Grubu"
    label-for="id_document_groups"
  >
    <validation-provider
      #default="{ errors }"
      name="Doküman Grubu"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_document_groups"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Doküman Grubu"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'PFDocumentGroupsSelectCard',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['documentGroups/dataList']
    },
    dataItem() {
      return this.$store.getters['productFiles/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('documentGroups/getDataList')
    },
  },
}
</script>
